const QUEUE = [];
let cookiebotListenerSetup = false;

export function isDevEnv() {
    return ['dev-stg.cs55'].some(
        (hostname) => typeof window !== 'undefined' && window.location.hostname.includes(hostname),
    );
}

function handleCookieAcceptance() {
    QUEUE.forEach((callback) => {
        if (typeof callback === 'function') {
            callback();
        }
    });
    QUEUE.length = 0; // Clear the queue
}

function ensureCookiebotListener() {
    if (cookiebotListenerSetup) {
        return;
    }
    // Ensure addEventListener is only called in a browser environment
    if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
        window.addEventListener('CookiebotOnAccept', handleCookieAcceptance, false);
        cookiebotListenerSetup = true;
    }
}

function hasCookiesBeenAccepted() {
    if (isDevEnv()) {
        return true;
    }
    // Ensure this function is also environment-aware for SSR scenarios
    if (typeof window === 'undefined' || !window.Cookiebot) {
        return false;
    }
    return window.Cookiebot.consented;
}

export function executeWhenCookiesAccepted(callback) {
    // If in a test environment, execute the callback immediately
    if (process.env.NODE_ENV === 'test') {
        if (typeof callback === 'function') {
            callback();
        }
        return;
    }

    // Ensure this function is also environment-aware for SSR scenarios
    if (typeof window === 'undefined') {
        return;
    }

    if (typeof callback !== 'function') {
        return;
    }

    ensureCookiebotListener();

    if (hasCookiesBeenAccepted()) {
        callback(); // Cookies accepted, execute immediately
    } else {
        QUEUE.push(callback);
    }
}
